import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { FilePdf, CalendarCheck } from "@phosphor-icons/react";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import { api } from "../lib/api";
import { StepResults } from "../components/rollover/StepResults";
import { StepCompare } from "../components/rollover/StepCompare";
import { Disclosures } from "../components/rollover/YearTable";
import { money } from "../components/rollover/fields";

const LABELS = { "401k": "401(k)", trad_ira: "Traditional IRA", roth_ira: "Roth IRA", "403b": "403(b)", "457": "457(b)" };

export default function RolloverShare() {
  const { id } = useParams();
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { api.get(`/rollover/scenarios/${id}`).then((r) => setD(r.data)).catch(() => setErr("This scenario link isn't valid anymore.")); }, [id]);

  const pdf = async () => {
    const res = await api.get(`/rollover/scenarios/${id}/pdf`, { responseType: "blob" });
    const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
    const a = document.createElement("a"); a.href = url; a.download = "exodus-rollover-comparison.pdf"; document.body.appendChild(a); a.click(); a.remove();
  };

  return (
    <div data-testid="rollover-share-page" className="min-h-screen bg-exodus-bg text-exodus-text">
      <Nav />
      <main className="max-w-5xl mx-auto px-6 lg:px-12 pt-36 pb-24">
        {err && <p data-testid="rollover-share-error" className="text-exodus-muted">{err}</p>}
        {!d && !err && <p className="text-exodus-muted">Loading…</p>}
        {d && (
          <>
            <p className="eyebrow"><span className="gold-divider" />Shared rollover scenario</p>
            <h1 data-testid="rollover-share-title" className="font-display text-4xl sm:text-5xl mt-4 leading-tight">
              {d.first_name ? `${d.first_name}'s` : "A"} {LABELS[d.inputs.client.source]} rollover: {money(d.inputs.client.amount)} into {d.inputs.product === "iul" ? "an IUL" : "an FIA"}
            </h1>
            <p className="text-sm text-exodus-muted mt-4">Hypothetical, educational model. {d.inputs.scenario} scenario. Updated {new Date(d.updated_at).toLocaleDateString()}.</p>
            <div className="flex flex-wrap gap-3 mt-8">
              <button type="button" data-testid="rollover-share-pdf" onClick={pdf} className="inline-flex items-center gap-2 border border-exodus-border px-4 py-3 text-sm hover:border-exodus-gold"><FilePdf size={16} className="text-exodus-gold" />Download PDF</button>
              <Link to="/calculator?product=rollover" data-testid="rollover-share-try" className="inline-flex items-center gap-2 border border-exodus-border px-4 py-3 text-sm hover:border-exodus-gold">Run my own numbers</Link>
              <Link to="/reserve" data-testid="rollover-share-book" className="btn-gold inline-flex items-center gap-2"><CalendarCheck size={16} />Schedule an Illustration Review</Link>
            </div>
            <div className="mt-12 space-y-14">
              <StepResults inputs={{ ...d.inputs, iul: { ...d.inputs.iul, mec_acknowledged: true } }} result={d.result} onAckMec={() => {}} />
              <StepCompare result={d.result} product={d.inputs.product} />
            </div>
            <Disclosures />
          </>
        )}
      </main>
      <Footer />
    </div>
  );
}
